import React, { useState, useEffect, useRef } from "react";
import Header from "../app/Header";
import { Col, Container, ListGroup, Row } from "react-bootstrap";
import TreeMenu from "react-simple-tree-menu";
import { TreeItem } from "./TreeItem";
import "../../../node_modules/react-simple-tree-menu/dist/main.css";
import { useSearchParams } from "react-router-dom";
import { Form } from "react-bootstrap";
import "./Products.scss";
import { useLang } from "../../common/hooks/useLang";
import ProductHelper from "./ProductHelper";
import axios from "../../common/api/HttpClient";
import { useTranslation } from "react-i18next";
import { NAMESPACE_REMOTE } from "../../common/translations/TranslationHelper";
import { useToken } from "../../common/hooks/useToken";
import { TOKEN_KEY_FIRM_ID } from "../../common/helpers/TokenHelper"
import { DefaultLoadingIndicator } from "../app/LoadingIndicator";

export default function Products() {

  const { currentLanguage } = useLang();

  const { t } = useTranslation(NAMESPACE_REMOTE);

  const { accessToken } = useToken();
  const [products, setProducts] = useState(null);
  useEffect(() => {
    let notInterrupted = true;

    setProductsLoading(true);
    const userFirmId = accessToken.decodedToken[TOKEN_KEY_FIRM_ID];
    axios({
      method: "get",
      url: "/product-catalogue",
      params: { firmaId: userFirmId, sprache: currentLanguage }
    })
      .then((response) => {
        if (notInterrupted) {
          setProducts(response.data.data);
          setProductsLoading(false);
        }
      })
      .catch((error) => {
        console.error(error);
        setProductsLoading(false);
      });

    // If clean-up function executes, the axios call was interrupted
    // and the results can not be rendered in the dom anymore.
    // This may happen, if the user navigates back during the call.
    return () => {
      notInterrupted = false;
    }
  }, [accessToken.decodedToken, currentLanguage]);

  const [treeModel, setTreeModel] = useState(null);
  useEffect(() => {
    if (products != null && products.length > 0) {
      setTreeModel(ProductHelper.getProductsForTreeModel(products));
    }
  }, [products]);

  let [searchParams] = useSearchParams();
  let filterPreset = searchParams.get("filter");
  const [filter, setFilter] = useState("");
  const treeMenu = useRef();
  const inputFilterRef = useRef(filterPreset);
  useEffect(() => {
    if (filterPreset != null) {
      setFilter(filterPreset);
      treeMenu.current.search(filterPreset);
    }
  }, [filterPreset]);

  let [closePopupFunctions, setClosePopupFunctions] = useState([]);
  const handleAddClosePopupFunctionToQueue = (closePopupFunction) => {
    setClosePopupFunctions(closePopupFunctions.concat(closePopupFunction));
  }
  const handleCloseAllPopups = () => {
    for (const closePopupFunction of closePopupFunctions) {
      closePopupFunction();
    }
    setClosePopupFunctions([]);
  }

  const customSearch = (search) => {
    let nodes = [];
    const nodeWithChildren = ProductHelper.getAllChildren(products, search.key, true);
    nodes = nodes.concat(nodeWithChildren);
    const parents = ProductHelper.getAllParents(products, search.key);
    nodes = nodes.concat(parents);

    const regex = new RegExp(search.searchTerm, "i");
    for (let i = 0; i < nodes.length; i++) {
      const node = nodes[i];
      const attribute = currentLanguage === "en" ? node["PARAMETER4"] : node["PARAMETER3"];
      if (attribute.search(regex) !== -1) {
        return true;
      }
    }

    return false;
  }

  const [isProductsLoading, setProductsLoading] = useState(undefined);

  return (
    <Container className="p-0" fluid>
      <header>
        <Header title={t("PROMPT.WSHOP2.PRODUCTS.TITLE")}></Header>
      </header>

      <main>
        <Container fluid="md" className="pt-3">
          <Row>
            <Col>
              <h1 className="h2">{t("TEXT.WSHOP2.PRODUCTS.HEADLINE_1")}</h1>
              <p>{t("TEXT.WSHOP2.PRODUCTS.HEADLINE_2")}</p>
            </Col>
          </Row>
          <TreeMenu data={treeModel} ref={treeMenu} 
                    matchSearch={customSearch}
          >
            {({ search, items }) => (
              <>
                <Form.Control
                  id="inputFilter"
                  ref={inputFilterRef}
                  value={filter}
                  className="mb-2"
                  onChange={(e) => {
                    search(e.target.value);
                    setFilter(e.target.value);
                  }}
                  placeholder={t("TEXT.WSHOP2.PRODUCTS.SEARCH_ANALYSIS")}
                  autoComplete="off"
                />
                { isProductsLoading === true && DefaultLoadingIndicator() }
                { isProductsLoading === false &&
                  <ListGroup>
                    {items.map(({ key, ...props }) => (
                      <TreeItem
                        className="list-group-item"
                        key={key}
                        handleAddClosePopupFunctionToQueue={handleAddClosePopupFunctionToQueue}
                        handleCloseAllPopups={handleCloseAllPopups}
                        {...props}
                      />
                    ))}
                  </ListGroup>
                }
              </>
            )}
          </TreeMenu>
        </Container>
      </main>
    </Container>
  );
}
